<template>
  <div class="app">
    <NuxtLoadingIndicator color="hsl(133 66% 74% / 95%)" error-color="hsl(10 100% 62% / 95%)" />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <UIDialog />
  </div>
</template>
